import { InstallationsApiView } from 'src/Libs/installations/components/InstallationsApiView'
import { getNewInstallationFetchProps } from 'src/Libs/installations/utils/installation-table-columns'
import React from 'react'
import { Installation } from 'src/Libs/installations/models/installation.model'
import { useNavigate } from 'react-router-dom'
import { BlankViewImageVariants, BlankView, BlankViewImageSizes } from 'src/Components/blank-view'

interface NewestInstallationsProps {
  showStatusColumn?: boolean
  onSelect: (installation?: Installation) => void
}

/**
 * Component in to display the newest installations in the overview
 */
const NewestInstallations: React.FC<NewestInstallationsProps> = ({ showStatusColumn = false, onSelect }) => {
  const navigate = useNavigate()

  return (
    <InstallationsApiView
      keyValue={0}
      fetchProps={getNewInstallationFetchProps()}
      dataQaPrefix={'installations-incomplete'}
      onSelect={onSelect}
      showStatus={showStatusColumn}
      blankView={
        <BlankView
          imageVariant={BlankViewImageVariants.Neutral}
          imageSize={BlankViewImageSizes.Small}
          title={'companyDashboard.blank-view.newest-installation.title'}
          explanation={'companyDashboard.blank-view.newest-installation.explanation'}
          action={{
            text: 'companyDashboard.missingIbn',
            onClick: () => navigate('/installer-dashboard/missing-ibn'),
          }}
          fullHeight
        />
      }
      showOptionsMenu
    />
  )
}

export default NewestInstallations
